import GeoJSON from 'ol/format/GeoJSON';
import { extend } from 'ol/extent';
const geoJSONFormatter = new GeoJSON();
export const getExtent = (geoJSONFeature) => {
    const feature = geoJSONFormatter.readFeature(geoJSONFeature);
    const featureGeometryExtent = feature?.getGeometry()?.getExtent();
    return featureGeometryExtent ?? undefined;
};
export const getFeaturesExtent = (features) => {
    let extent;
    features.forEach((feature) => {
        const featureExtent = getExtent(feature);
        if (extent) {
            featureExtent && extend(extent, featureExtent);
        }
        else {
            extent = featureExtent;
        }
    });
    return extent;
};
const geoJsonFormat = new GeoJSON();
export const geoJSONToGeometry = (geoJSONFeature) => {
    return geoJsonFormat.readGeometry(geoJSONFeature);
};
// TODO: da se nejak zachovat referencni identita na vracenou featuru podle layerId a id???
export const geoJSONToFeature = (geoJSONFeature) => {
    const feature = geoJsonFormat.readFeature(geoJSONFeature);
    if (geoJSONFeature.crs) {
        feature.set('_crs', geoJSONFeature.crs);
    }
    return feature;
};
//# sourceMappingURL=geoJSONFeature.js.map